export const fullWidthRegex = /[\uFF00-\uFFEF\u3000-\u303F]/

export const replaceStringToNumber = /[^０-９0-9．.]/g

export const digitRegex = /\D/g

export const emailRegex = /[a-zA-Z0-9]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{2,3}/

export const whiteSpaceRegex = /^\s*$/;